<template>
<!-- BOTOES NO TOPO FORMATO MENU PARA SELECIONAR O MODEL DO CRUD. RETORNAR O PATH  -->
  <div class="text-center">
    <v-container class="pa-0">
      <v-btn-toggle mandatory background-color="background">
        <v-row justify="center">
          <!-- <v-col cols="12" sm="4"  class="pa-0"> -->
            <v-btn v-for="(option, i) in options" :key="i" small rounded color="tertiary" light class="ma-1" @click="Select(option.value)">{{option.text}}</v-btn>
          <!-- </v-col> -->
        </v-row>
      </v-btn-toggle>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: [
        { text: "Clientes", value: "Company" },
        { text: "Soluções", value: "Solution" },
        // { text: "Propostas", value: "Proposal" },
        // { text: "Features", value: "Feature" },
        { text: "Arquivos base para importação", value: "DefaultImportFile" },
      ],
      selected: "Company"
    };
  },
  methods: {
    Select(set) {
      if(set != this.selected){
        this.selected = set
        this.$emit('getCrud', this.selected)
      }
    }
  },

};
</script>

